import React from 'react';  
import { connect } from 'react-redux'
import { Container } from 'react-bootstrap'
import Row from 'react-bootstrap/Row'
//import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'

import Menu from './Menu.jsx';
import Help from './help';
//import Login from './Login.jsx';
import TokenAcquisition from './MsalLogin';
import Logging from './Logging.jsx';
import Report from './Report.jsx';
import PeriodSelector from './PeriodSelector.jsx';
import PeriodLogging from './PeriodLogging.jsx';
import { WL, WL_SUCCESS, WL_FAIL, WL_EXCEPTION, WL_UNAUTHORIZED, WL_SetHost } from './WebLoggerService.jsx'

import { ACT_LOGIN, ACT_LOGOUT, ACT_GOTLOGS, ACT_GOTHOLIDAYPROJECTS, ACT_GOTILLNESSPROJECTS, ACT_GOTJOBDAYINFO } from './actions.js'
import Collapse from 'react-bootstrap/Collapse'

import ReactQueryParams from 'react-query-params'




class Main extends ReactQueryParams /*React.Component*/ { 

    constructor(props, store) {
        super(props);
		this.state = {  /*ready:false*/}
		this.LoginResult = this.LoginResult.bind(this);
		this.GetLogsResult = this.GetLogsResult.bind(this)
		this.GetHolidaysResult = this.GetHolidaysResult.bind(this)
		this.GetIllnessResult = this.GetIllnessResult.bind(this)
		this.GetJobDayInfoResult = this.GetJobDayInfoResult.bind(this)
		this.doLogin = this.doLogin.bind(this)
		WL_SetHost(props.cfg.webloggerapi)
		
		
    }
	
	componentDidMount()
	{
		//if (this.props.user !== '') {
			if (this.props.token !== '') {
				//console.log("WL_Login with token " + this.props.token)
				//WL.Login(this.props.token, this.props.user, null, null, this.LoginResult)
				this.doLogin(null)
			}
		//}
		/*else if (this.props.authtoken !== '') {
			//WL.Login(this.props.token, this.props.user, null, this.props.authtoken, this.LoginResult)
			this.doLogin(this.props.authtoken)
		}*/
		
	}

	doLogin(authtoken) {
		WL.Login(this.props.token, this.props.user, null, authtoken, this.LoginResult)
	}

	LoginResult(result, data) {
		if (result === WL_EXCEPTION) {
			this.setState({ showError: true, errMsg: "Kan geen verbinding met LoginServer maken" })
		} else if (result === WL_FAIL) {
			this.setState({ showError: true, errMsg: "Gebruikersnaam en wachtwoord zijn geen geldige combinatie" })
			this.props.logout()
		} else if (result === WL_SUCCESS) {
			this.props.login(data.username, data.userInfo)
			//WL.GetLogs(data.userInfo.token, this.GetLogsResult)
			WL.GetProjects(data.userInfo.token, "holidays", this.GetHolidaysResult, data.userInfo.token)
		}
	}
	GetJobDayInfoResult(result, data, token) {
		if (result === WL_EXCEPTION) {
			console.log("Exception while getting jobdayinfo")
		} else if (result === WL_FAIL) {
			console.log("Failed to get jobdayinfo")
		} else if (result === WL_SUCCESS) {
			this.props.gotJobDayInfo(data)
			WL.GetLogs(token, this.GetLogsResult)

		}
	}
	GetLogsResult(result, data) {
		if (result === WL_EXCEPTION) {
			console.log("Exception while getting logs")
		} else if (result === WL_FAIL) {
			console.log("Failed to get logs")
		} else if (result === WL_SUCCESS) {
			this.props.gotLogs(data)
			//console.log("SETTING READY TO TRUE")
			//this.setState({ ready: true })

		}
	}

	
	GetHolidaysResult(result, data, token) {
		if (result === WL_UNAUTHORIZED) {
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			this.setState({ showError: true, errMsg: "Failed to contact the server" })
		} else if (result === WL_FAIL) {
			this.setState({ showError: true, errMsg: "Failed to retrieve the holidayprojects" })
		} else if (result === WL_SUCCESS) {
			this.props.gotHolidayProjects(data)
			WL.GetProjects(token, "illness", this.GetIllnessResult, token)

		}
	}
	GetIllnessResult(result, data, token) {
		if (result === WL_UNAUTHORIZED) {
			this.props.logout()
		} else if (result === WL_EXCEPTION) {
			this.setState({ showError: true, errMsg: "Failed to contact the server" })
		} else if (result === WL_FAIL) {
			this.setState({ showError: true, errMsg: "Failed to retrieve the illnessprojects" })
		} else if (result === WL_SUCCESS) {
			this.props.gotIllnessProjects(data)
			WL.GetJobDayInfo(token, this.GetJobDayInfoResult, token)
		}
	}
    
	render() {
		

		//console.log("render main("+this.props.ready+")")
		var login = ''
		var menu = ''
		var logging = ''
		var loggingOverview = ''
		var report = ''
		var periodSelection = ''
		var help = ''
		var waiting=''
		//console.log("loggedIn:" + this.props.loggedIn)
		if (/*this.props.user==='' || this.props.user===undefined ||*/ this.props.loggedIn !== true) {
			//console.log("not logged in")
			login = <TokenAcquisition login={this.doLogin}></TokenAcquisition>
			menu = <Menu state={false} ></Menu>
		}
		else if (!this.props.ready) {
			waiting = <Spinner style={{position: "fixed",top: "50%", left: "50%",	marginTop:"-50px",	marginLeft: "-25px"}} animation="grow" variant="primary" />
			
		}
		else if (this.props.ready){
			//console.log("allready logged in")
			menu = <Menu state={true}></Menu>
			periodSelection = <PeriodSelector />

			if (this.props.menu === 'help') {
				periodSelection = ''
				help = <Help />
			}

			else if (this.props.menu === 'logging') {
				//console.log("selected project = "+this.props.projId)
				loggingOverview = <PeriodLogging />
				//logging = <Logging projId={this.props.projId} projItemId={this.props.projItemId} lastLog={this.props.lastLog} />
				logging = <Logging />
			}
			else if (this.props.menu === 'holidayreport') {
				report = <Report type={"holiday"} />
			}
			else if (this.props.menu === 'distancereport') {
				report = <Report type={"distance"} />
			}
			else if (this.props.menu === 'logreport') {
				report = <Report type={"logging"} />
			}
			else if (this.props.menu === 'timesheetreport') {
				report = <Report type={"expertstimesheet"} />
			}
			else if (this.props.menu === 'summaryreport') {
				report = <Report type={"summaryreport"} />
			}
			/*else if (this.props.menu==='advreport') {
				report=<Report type={"adv"}/>
			}*/
		}


		return (

			<Container fluid={true} style={{ padding: "0px", backgroundImage: "url('bg.png')", backgroundSize: "100%", height: "100vh" }}>
				<div style={{ overflow: "auto", maxHeight: "100vh" }}>
					{menu}
					{login}
					{waiting}
					{help}
					<Container fluid={true} style={{ paddingTop: "15px", paddingBotom: "5px" }}>
						<Collapse style={{ width: "100%" }} in={!this.props.visible}>
							<div>{periodSelection}</div>
						</Collapse>
					</Container>
					<Container fluid={true} >
						<Row style={{padding:"0px",margin:"0px"}}>
						   <Collapse style={{width:"100%"}} in={!this.props.visible}>
								<div>{loggingOverview}</div>
							</Collapse>
						</Row>
					</Container>	
					<Container fluid={false} >
						<Collapse in={this.props.visible}>
							<div>{logging}</div>
						</Collapse>
					</Container>
					<Container fluid={true} >
					   {report}
					</Container>
				</div>
           </Container>
      );  
   }  
}  

function mapStateToProps(state) {
	return {
		user: state.user.user,
		token: state.user.userInfo["token"],
		authtoken: state.user.authtoken,
		menu: state.menu.menu,
		visible: state.app.edit,
		loggedIn: state.user.loggedIn,
		ready: state.app.logsReceived //(state.period.startLogs!=null && state.period.endLogs!=null)
		
	}
}
function mapDispatchToProps(dispatch) {
	return {
		logout: () => {
			console.log("logout due to expired token... ")
			dispatch({ type: ACT_LOGOUT })
		},
		login: (username, userInfo) => {
			//console.log("refreshed token...for user " + username +": userInfo.token(not set yet)")
			dispatch({ type: ACT_LOGIN, user: username, userInfo })
		},
		gotLogs: (data) => {
			dispatch({ type: ACT_GOTLOGS, logs: data })
		},

		gotHolidayProjects: (data) => {
			dispatch({ type: ACT_GOTHOLIDAYPROJECTS, holidayPrjs: data })
		},

		gotIllnessProjects: (data) => {
			dispatch({ type: ACT_GOTILLNESSPROJECTS, illnessPrjs: data })
		},
		gotJobDayInfo: (data) => {
			dispatch({ type: ACT_GOTJOBDAYINFO, jobDayInfo: data })
		}
	}

}
  
export default connect(mapStateToProps, mapDispatchToProps)(Main);  